import toast from "react-hot-toast";

import type {
  Invitation,
  OpenAPI,
  UseInvitationOptions,
} from "simplydo/interfaces";

import api from "api";

export const invalidateInvitationLists = () => {
  api.invalidateQueries(api.invitations.get);
  api.invalidateQueries(api.users.dashboard);
};

export const acceptAuthenticatedInvitation = (
  invitation: Invitation,
  onSuccess?: () => void,
  onError?: () => void,
) => {
  api.invitations.accept(
    invitation._id,
    () => {
      invalidateInvitationLists();
      onSuccess?.();
    },
    () => onError?.(),
  );
};

export const rejectAuthenticatedInvitation = (
  invitation: Invitation,
  onSuccess?: () => void,
  onError?: () => void,
) => {
  api.invitations.reject(
    invitation._id,
    () => {
      invalidateInvitationLists();
      onSuccess?.();
    },
    () => onError?.(),
  );
};

export const removeAuthenticatedInvitation = (
  invitation: Invitation,
  onSuccess?: () => void,
  onError?: () => void,
) => {
  api.invitations.remove(
    invitation._id,
    () => {
      invalidateInvitationLists();
      onSuccess?.();
    },
    () => onError?.(),
  );
};

export const acceptTokenInvitation = (
  token: string,
  onSuccess?: () => void,
  onError?: () => void,
) => {
  api.invitations.acceptToken(
    token,
    () => {
      invalidateInvitationLists();
      onSuccess?.();
    },
    () => onError?.(),
  );
};

export type InvitationAcceptResponse =
  OpenAPI.POST<"/invitations/{id}/accept">["response"];

export const toastSuccess = (message: string) => {
  toast.success(message);
};

export const toastError = (message: string) => {
  toast.error(message);
};

export const toastMessage = (message: string) => {
  toast(message);
};

export const withInvitationPrompt = (
  options: UseInvitationOptions | undefined,
  title: string,
  message: string,
  onConfirm: () => void,
) => {
  if (options?.onAccept) {
    options.onAccept({ title, message, confirm: onConfirm, cancel: () => {} });
    return;
  }
  onConfirm();
};
